module.exports = {
  apiKey: 'AIzaSyCj7kt3e7Y6o006fxWaO56D6a576zgVVi8',
  authDomain: 'antaa-qa.firebaseapp.com',
  databaseURL: 'https://antaa-qa.firebaseio.com',
  projectId: 'antaa-qa',
  storageBucket: 'antaa-qa.appspot.com',
  messagingSenderId: '616775165416',
};
